/**
 * 退换货服务弹窗
 */
import React, { useState, useCallback, useEffect } from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { doProductMobx } from 'mobx/mall'
import { observer } from 'mobx-react'
import { toast, showMsg } from '@utils'
import i18n from 'i18next'
import repositoryMobx from '@mobx/mall/repository.mobx'
import { SelectScales } from '@pages/mall/product/component'
import { Stepper, Icon } from 'components'

import './index.scss'

interface ICartProps {
  reject?: () => void;
  resolve?: () => void;
}

const ReturnServiceModal: React.FC<ICartProps> = ({ reject, resolve }) => {
  return (
    <IonModal
      isOpen
      cssClass='mall-product-scale-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='modal-title'>{i18n.t('mall.returnService')}</div>
        <Icon name='close' onClick={reject} />
      </IonHeader>
      <IonContent>
        <div className='return-container'>
          <p className='detail-introduce' dangerouslySetInnerHTML={{ __html: repositoryMobx.info.returnIntro }}></p>
        </div>
      </IonContent>
      <IonFooter className='mall-footer-btn-wrap'>
        <div className='footer-btn'>
          <button
            className='primary-btn'
            onClick={() => reject()}
          >
            {i18n.t('newCart.confirm')}
          </button>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ReturnServiceModal)
